// src/Components/Utils/Portal.tsx
import { ReactNode } from "react";
import { createPortal } from "react-dom";

interface PortalProps {
  children: ReactNode;
  containerId?: string; // default = "overlay-root"
}

const Portal = ({ children, containerId = "overlay-root" }: PortalProps) => {
  const el = document.getElementById(containerId);
  // Fallback to body if someone removes the div by mistake
  return createPortal(children, el ?? document.body);
};

export default Portal;
